import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  rightSection: {
    minHeight: "78vh",
    "& .MuiCard-root": {
      height: "100%",
    },
    [theme.breakpoints.up("xs")]: {
      width: "calc(100% - 290px)",
      marginLeft: 24,
    },
  },
  headerSection: {
    width: "calc(100% - 100px)",
    "& .MuiFormControl-root": {
      width: 230,
      marginRight: 15,
    },
    "& .MuiInputLabel-formControl": {
      margin: 0,
    },
    "& .frequency-field": {
      padding: 0,
      "& .MuiSelect-selectMenu": {
        padding: "14px 12px",
        width: "78%",
      },
    },
    "& .user-filter": {
      "& .MuiSelect-selectMenu": {
        padding: "8px 12px",
        "& .avatar-img": {
          height: 28,
          width: 28,
          fontSize: 14,
        },
      },
      "& .user-name": {
        display: "block",
        width: "65%",
      },
    },
  },
  checkinType: {
    borderBottom: "solid 1px #ECEEF2",
    padding: "16px 24px",
  },
  media: {
    "& img, & video": {
      width: "100%",
      height: 120,
    },
  },
  subTable: {
    margin: "-10px -12px",
    "& .k-grid-header": {
      display: "none",
    },
    "& .k-master-row": {
      "& td": {
        background: "#F5F5F5",
      },
    },
  },
  rating: {
    pointerEvents: "none",
  },
  emojiBarChart: {
    "& image": {
      width: 35,
      height: 35,
    },
  },
  emojiImages: {
    width: 36,
    display: "block",
  },
  donutChart: {
    "& .k-chart": {
      height: "200px !important",
      "& .k-chart-donut-center": {
        "& span": {
          "& h2": {
            fontSize: 20,
          },
          "& h4": {
            fontSize: 15,
          },
        },
      },
    },
  },
  starRatingSummary: {
    "& .k-chart": {
      height: 200,
    },
  },
  correctIcon: {
    color: "#009C55",
  },
  gridDataChart: {
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  emojiImage: {
    width: 30,
  },
  descriptiveStatistics: {
    "& ul": {
      margin: 0,
      padding: 0,
      listStyle: "none",
    },
    "& .k-gauge": {
      width: 65,
      height: 65,
    },
    "& h6": {
      lineHeight: "24px",
    },
  },
  response: {
    textAlign: "center",
    width: "20%",
  },
  questionTxt: {
    width: "80%",
  },
  gridDetails: {
    margin: 0,
    padding: "0 0 0 15px",
    "& li": {
      borderBottom: "solid 1px rgb(204 204 204 / 80%)",
      padding: "10px 0",
    },
  },
  checkinDetailGrid: {
    "& .k-grid table tbody tr.k-detail-row, .k-grid table tbody tr.k-detail-row .k-hierarchy-cell":
      {
        background: "#FCFCFD",
      },
  },
  questionHeader: {
    "& span": {
      background: "#FCFCFD",
      position: "absolute",
      paddingRight: 10,
    },
    position: "relative",
    height: 30,
    "&:before": {
      width: "100%",
      height: 1,
      background: "rgb(204 204 204 / 80%)",
      content: '""',
      position: "absolute",
      top: 10,
    },
  },
  commentBlock: {
    background: "#F1F4F6",
  },
  kendoGraph: {
    "& .k-chart": {
      height: 280,
    },
  },
  dropdown: {
    width: "150px",
  },
  skillName: {
    height: 1,
    background: "#CAD4DD",
    marginTop: 70,
    "& h6": {
      position: "absolute",
      background: "#fff",
      top: 0,
      fontSize: 16,
      top: -13,
      left: 0,
      right: 0,
      margin: "0 auto",
      width: "fit-content",
      padding: "0 16px",
    },
  },
}));
